module.exports = __webpack_public_path__ + "static/media/person01.09d2aa97.png";